export default class MastheadCompactNavController {
  constructor() {
    // handle the masthead dropdown
    this.currentEl = null;
    this.delay = 300;
    let menuEnterTimer, menuLeaveTimer;
    this.menuEnterTimer = menuEnterTimer;
    this.menuLeaveTimer = menuLeaveTimer;
  }

  onMenuItemEnter = ( el ) => {
    el.classList.add( 'sub-menu-open' );
  }

  onMenuItemLeave = ( el ) => {
    el.classList.remove( 'sub-menu-open' );
  }

  removeAriaExpanded = ( el ) => {
    el.querySelectorAll( '[aria-expanded="true"]' ).forEach( ( ( e ) => {
      e.setAttribute( 'aria-expanded', 'false' )
			e.parentNode.classList.remove( 'sub-menu-open' );
    } ) )
  }

  addAriaExpanded = ( el ) => {
    let nearest = el.target.closest( '[aria-expanded]' );

    if ( 'true' === nearest.getAttribute( 'aria-expanded' ) ) {
      this.removeAriaExpanded( nearest.closest( '.menu-item-has-children' ) );
			el.target.parentNode.classList.remove('sub-menu-open');
    } else {
      nearest.setAttribute( 'aria-expanded', 'true' )
			el.target.parentNode.classList.add( 'sub-menu-open' );
    }
  }

	getLinkUrl = (item) => {
		item.addEventListener( 'click', ( e ) => {
			window.location.href = e.target.querySelector( 'a' ).href
		} )
	}

	setSubmenuWidth = (item) => {
		const labelWidth = item.clientWidth;
		const menu = item.querySelector('.sub-menu');
		if ( menu ) {
			const menuWidth = menu.clientWidth;
			// if submenu width is smaller than the label, make it the same size
			if ( menuWidth < labelWidth ) {
				// set the menu parent and submenu
				// add 1px in case elment was rounded down on floating integers
				item.style.width = `${ labelWidth + 1 }px`;
				menu.style.minWidth = `${ labelWidth + 1 }px`; // add 1px to match
			}
		}
	}

  init () {
		document.querySelectorAll( '.compact-masthead li.menu-item' ).forEach( ( menuItem ) => {
			this.getLinkUrl(menuItem)
		}),
		document.querySelectorAll( '.compact-masthead li.menu-item-has-children' ).forEach( ( menuItem ) => {
			this.setSubmenuWidth(menuItem)
		} ),
		document.querySelectorAll( '.compact-masthead .menu-item-has-children button' ).forEach( ( ( e ) => {
			e.addEventListener( 'click', (evt) => {
				this.addAriaExpanded(evt)
			} )
		}
		) ),
		document.addEventListener( 'click', ( ( t ) => {
			document.querySelectorAll( '.masthead-navigation' ).forEach( ( n ) => {
				n.contains( t.target ) || this.removeAriaExpanded( n )
			} )
		}
		) ),
		document.addEventListener( 'keyup', ( ( t ) => {
			document.querySelectorAll( '.compact-masthead li.menu-item-has-children' ).forEach( ( n ) => {
				if ( n.contains( t.target ) ) {
					if ( 'Escape' === t.key ) {
						n.classList.remove('sub-menu-open');
						const t = n.querySelector( '[aria-expanded="true"]' );
						this.removeAriaExpanded( n ),
							null == t || t.focus()
					}
				} else {
					this.removeAriaExpanded( n )
				}
			} )
		}
		) )

  }
}
